import { useRef } from 'react';

import { ProceduralUploadDialog } from './procedural-upload-dialog';
import { useProceduralUpload } from './use-procedural-upload';
import { Permission } from '../../../../../../../../backend/src/auth/permissions/permission';
import { PermissionGate } from '@/hooks/useHasPermission';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/new/components/shadcn/tooltip';

const ACCEPT_ATTR =
  '.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

interface UploadTimetableButtonProps {
  matterId: string;
}

export function UploadTimetableButton({ matterId }: UploadTimetableButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const upload = useProceduralUpload({ matterId });

  const handleClick = () => inputRef.current?.click();

  const handleFileSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (file) upload.acceptFile(file);
  };

  const button = (
    <Button variant="primary" onClick={handleClick} disabled={upload.isDisabled}>
      <Icon className="lucide--upload" />
      Extract From Timetable
    </Button>
  );

  return (
    <PermissionGate permission={Permission.ProceduralTimelineEdit} uiMode="disabled">
      <>
        <input ref={inputRef} type="file" accept={ACCEPT_ATTR} className="hidden" onChange={handleFileSelected} />

        {upload.blockedReason && upload.isDisabled ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <span tabIndex={0}>{button}</span>
            </TooltipTrigger>
            <TooltipContent>{upload.blockedReason}</TooltipContent>
          </Tooltip>
        ) : (
          button
        )}

        <ProceduralUploadDialog upload={upload} />
      </>
    </PermissionGate>
  );
}
